"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var components = new WeakMap();
var keyMap = new Map();
function mountComponent(component) {
    if (!components.has(component)) {
        components.set(component, true);
        keyMap.set(component.key, component);
    }
}
exports.mountComponent = mountComponent;
function unmountComponent(component) {
    if (components.has(component)) {
        components.delete(component);
        keyMap.delete(component.key);
    }
}
exports.unmountComponent = unmountComponent;
function updateState(action) {
    var component = keyMap.get(action.key);
    if (component) {
        component.updateAsyncState(action.asyncState);
    }
}
exports.updateState = updateState;
//# sourceMappingURL=asyncComponentTracker.js.map